import image1_0 from "../../assets/images/paintings/11/1.jpg";
import image1_1 from "../../assets/images/paintings/11/IMG-20241203-WA0033.jpg";
import image1_2 from "../../assets/images/paintings/11/IMG-20241208-WA0005.jpg";

import image2_0 from "../../assets/images/paintings/15/1.jpg";
import image2_1 from "../../assets/images/paintings/15/2.jpg";

import image3_0 from "../../assets/images/paintings/3/1.jpg";
import image3_1 from "../../assets/images/paintings/3/IMG-20241204-WA0023.jpg";
import image3_2 from "../../assets/images/paintings/3/IMG-20241204-WA0033.jpg";
import image3_3 from "../../assets/images/paintings/3/IMG-20241204-WA0035.jpg";
import image3_4 from "../../assets/images/paintings/3/IMG-20241208-WA0007.jpg";
import image3_5 from "../../assets/images/paintings/3/Изображение WhatsApp 2024-12-03 в 21.03.53_48754d7b.jpg";
import image3_6 from "../../assets/images/paintings/3/Изображение WhatsApp 2024-12-03 в 21.04.04_d7eb1be4.jpg";

import image4_0 from "../../assets/images/paintings/17/1.jpg";

import image5_0 from "../../assets/images/paintings/16/1.jpg";

import image6_0 from "../../assets/images/paintings/2/1.jpg";
import image6_1 from "../../assets/images/paintings/2/IMG-20241203-WA0025.jpg";
import image6_2 from "../../assets/images/paintings/2/IMG-20241204-WA0003.jpg";
import image6_3 from "../../assets/images/paintings/2/IMG-20241204-WA0014.jpg";
import image6_4 from "../../assets/images/paintings/2/IMG-20241204-WA0016.jpg";
import image6_5 from "../../assets/images/paintings/2/IMG-20241204-WA0028.jpg";

import image7_0 from "../../assets/images/paintings/14/photo_2024-12-27_14-44-24.jpg";

import image8_0 from "../../assets/images/products/image_7_0.jpeg";

import image9_0 from "../../assets/images/products/image_8_0.png";
import image9_1 from "../../assets/images/products/image_8_1.png";

import image10_0 from "../../assets/images/products/image_10_0.jpeg";

import image11_0 from "../../assets/images/products/image_11_0.jpeg";

import image12_0 from "../../assets/images/paintings/12/IMG-20241204-WA0013.jpg";
import image12_1 from "../../assets/images/paintings/12/IMG-20241208-WA0001.jpg";
import image12_2 from "../../assets/images/paintings/12/IMG-20241208-WA0002.jpg";

import image13_0 from "../../assets/images/paintings/7/7.jpg";
import image13_1 from "../../assets/images/paintings/7/2.jpg"
import image13_2 from "../../assets/images/paintings/7/3.jpg"
import image13_3 from "../../assets/images/paintings/7/4.jpg"
import image13_4 from "../../assets/images/paintings/7/5.jpg"
import image13_5 from "../../assets/images/paintings/7/6.jpg"
import image13_6 from "../../assets/images/paintings/7/1.jpg"

import image14_0 from "../../assets/images/paintings/1/1.jpg";
import image14_1 from "../../assets/images/paintings/1/2.jpg";
import image14_2 from "../../assets/images/paintings/1/IMG-20241204-WA0010.jpg";
import image14_3 from "../../assets/images/paintings/1/Изображение WhatsApp 2024-12-03 в 21.03.56_86324a72.jpg"
import image14_4 from "../../assets/images/paintings/1/Изображение WhatsApp 2025-01-25 в 16.55.03_85a5d36d.jpg"

import image15_0 from "../../assets/images/paintings/10/IMG-20241204-WA0001.jpg";
import image15_1 from "../../assets/images/paintings/10/IMG-20241204-WA0002.jpg";
import image15_2 from "../../assets/images/paintings/10/IMG-20241204-WA0030.jpg";
import image15_3 from "../../assets/images/paintings/10/IMG-20241204-WA0031.jpg";
import image15_4 from "../../assets/images/paintings/10/IMG-20241208-WA0014.jpg";
import image15_5 from "../../assets/images/paintings/10/Изображение WhatsApp 2024-12-03 в 21.03.52_6d934302.jpg";
import image15_6 from "../../assets/images/paintings/10/Изображение WhatsApp 2024-12-03 в 21.04.03_7f9bc1bd.jpg";

export const products = [

  {
    _id: 1,
    titleEN: "Symphony",
    titleRU: "Симфония",
    titleAM: "Սիմֆոնիա",
    imgs: [
      image12_0 , image12_1 , image12_2
    ],
    descriptionRU:
      "Эта картина представляет собой красочную симфонию природы. Букет изящных цветов, написанный в ярких оттенках пурпурного, розового, зелёного и золотого, символизирует гармонию и жизненную энергию. Линии и формы композиции напоминают музыкальное движение, будто каждый лепесток танцует под звуки мелодии. Фон, наполненный оттенками фиолетового и голубого, добавляет глубины и усиливает ощущение радости и творчества.",
    descriptionEN:
      "This painting represents a colorful symphony of nature. A bouquet of delicate flowers, painted in vibrant shades of purple, pink, green, and gold, symbolizes harmony and life’s energy. The lines and shapes in the composition evoke musical movement, as if every petal dances to the sound of a melody. The background, filled with shades of violet and blue, adds depth and enhances the feeling of joy and creativity.",
    descriptionAM:
      "Այս նկարը բնության վառ սիմֆոնիան է։ Պայծառ գույներով՝ մանուշակագույն, վարդագույն, կանաչ և ոսկեգույն ծաղիկների փունջը խորհրդանշում է ներդաշնակություն և կյանքի էներգիա։ Կոմպոզիցիայի գծերն ու ձևերը հիշեցնում են երաժշտական շարժում՝ կարծես յուրաքանչյուր թերթիկ պարում է մեղեդու հնչյունների ներքո։ Հատակագիծը՝ լի մանուշակագույնի և կապույտի երանգներով, խորություն է հաղորդում և ուժեղացնում ուրախության և ստեղծագործության զգացողությունը։",
    instock: false,
    size: "100x70cm",
    timer: "2021.02.02",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2024-12-14T17:40:03.330Z",
    },
    __v: 0,
  },
  {
    _id: 2,
    titleEN: "Internal struggle",
    titleRU: "Внутренняя борьба",
    titleAM: "Ներքին պայքար",
    imgs: [image1_0, image1_1, image1_2],
    descriptionRU:
      "Фигура срастается с природой: из рук прорастают листья и ветви, закрывая часть взгляда.Это образ тишины, уязвимости и внутреннего роста, где человек и природа становятся единым целым.",
    descriptionEN:
      "The figure merges with nature: leaves and branches grow from the hands, partially covering the gaze.It is an image of silence, vulnerability, and inner growth, where human and nature become one.",
    descriptionAM:
      "Կերպարը միաձուլվում է բնության հետ․ ձեռքերից աճում են տերևներ ու ճյուղեր՝ ծածկելով հայացքի մի մասը։Սա լռության, խոցելիության և ներքին աճի պատկեր է, որտեղ մարդն ու բնությունը մեկ ամբողջություն են։",
    instock: true,
    size: "70x100 cm",
    timer: "2022.02.02",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2024-12-20T19:34:30.520Z",
    },
    __v: 2,
  },
  {
    _id: 3,
    titleEN: "Chaos",
    titleRU: "Хаос",
    titleAM: "Քաոս",
    imgs: [image7_0],
    descriptionRU:
      "Картина отражает сюрреалистический хаос, где переплетённые корни и фрагменты человеческих фигур сливаются с голубой струящейся тканью. Каждая деталь, от музыкальных символов до птиц, символизирует хрупкий баланс между беспорядком и гармонией, приглашая зрителя погрузиться в мир грёз.",
    descriptionEN:
      "The painting embodies surreal chaos, where intertwined roots and fragmented human figures merge with flowing blue fabric. Each detail, from musical symbols to small birds, symbolizes the fragile balance between disorder and harmony, inviting the viewer to dive into a dreamlike state.",
    descriptionAM:
      "Նկարը մարմնավորում է սյուրռեալ քաոսը, որտեղ միմյանց են միահյուսվում արմատներն ու մասնատված մարդկային կերպարները՝ կապույտ հոսող կտորով։ Ամեն մանրուք, երաժշտական խորհրդանիշներից մինչև փոքրիկ թռչուններ, արտացոլում է քաոսի և ներդաշնակության փխրուն հավասարակշռությունը՝ դիտողին հրավիրելով մտնել երազանման աշխարհ։",
    instock: false,
    size: "150x200 cm",
    timer: "2024-02-14",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2024-12-28T20:54:31.108Z",
    },
    __v: 1,
  },
  {
    _id: 4,
    titleEN: "New life",
    titleRU: "Новая жизнь",
    titleAM: "Նոր կյանք",
    imgs: [image8_0],
    descriptionRU:
      "Под небом — шахматная река чёрно-белых плит. Гигантские пальцы шепчут ходы судьбы, а девочка идёт к распахнутому свету, сквозь сплетение лабиринта и круга бытия, в поисках нового дыхания.",
    descriptionEN:
      "Beneath the sky — a chessboard river of black and white. Giant fingers murmur the moves of fate, while the girl walks toward the opened light, through the tangle of maze and circle of being, in search of a new breath.",
    descriptionAM:
      "Երկնքի տակ՝ շախմատի սև-սպիտակ ճանապարհ:Հսկա ձեռքերը շշնջում են ճակատագրի խաղաքարերը,իսկ աղջիկը՝ լույսի կանչով, քայլում է դեպի բացված դուռ՝լաբիրինթոսի ստվերների ու կյանքի շրջանակի միջով՝նոր շունչ փնտրելով:",
    instock: false,
    size: "150x200 cm",
    timer: "2024-02-14",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2024-12-28T20:54:31.108Z",
    },
    __v: 1,
  },
  {
    _id: 5,
    titleEN: "Silence",
    titleRU: "Тишина",
    titleAM: "Լռություն",
    imgs: [image9_0 , image9_1],
    descriptionRU:
      "Лодка, плывущая в тишине, с девушкой внутри. Обнажённые корни свисают с неба вместо кроны, рыбы парят в воздухе, птица замерла на борту. Все звуки умолкли — осталась только глубинная тишина.",
    descriptionEN:
      "A boat adrift in silence, carrying a girl’s soul. Bare roots hang from the sky where a tree should be, fish swim through the air, a bird rests on the edge. Every sound has fallen away — only profound quiet remains.",
    descriptionAM: "Լռության մեջ լողացող նավակ՝ աղջկա հոգու հետ: Մերկ արմատները կախված երկնքից՝ ծառի փոխարեն, ձկները լողում են օդում, թռչունը՝ նավակի եզրին: Բոլոր ձայները լուռ են, միայն խորքային խաղաղություն:",
    instock: false,
    size: "150x200 cm",
    timer: "2024-02-14",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2024-12-28T20:54:31.108Z",
    },
    __v: 1,
  },
  {
    _id: 6,
    titleEN: "Hell",
    titleRU: "Ад",
    titleAM: "Դժոխք",
    imgs: [
      image6_0,
      image6_1,
      image6_2,
      image6_3,
      image6_4,
      image6_5,
    ],
    descriptionRU:
      "Картина изображает сюрреалистическое видение ада, где человеческие фигуры переплетаются с колючими корнями и дымными завитками, оказавшись в ловушке мучений. Лица, искажённые болью, дьявольские образы и огненные оттенки создают атмосферу хаоса и страданий. Композиция насыщена деталями, где тьма перемежается с тревожным светом, подчёркивая угнетающую обстановку этого потустороннего ада.",
    descriptionEN:
      "The painting depicts a surreal vision of hell, where human figures intertwine with thorny roots and smoky tendrils, trapped in torment. Faces twisted in agony, devilish figures, and fiery colors create a sense of chaos and suffering. The composition is dense, with layers of darkness and eerie light breaking through, emphasizing the oppressive atmosphere of this otherworldly inferno.",
    descriptionAM:
      "Նկարը ներկայացնում է դժոխքի սյուրռեալ պատկեր, որտեղ մարդկային կերպարները միահյուսված են փշոտ արմատներով ու ծխացող գծերով՝ թակարդում տանջանքի մեջ։ Աղետի մռայլ դեմքեր, սատանայական կերպարներ և կրակի գույները ստեղծում են քաոսի ու տառապանքի զգացում։ Կոմպոզիցիան խիտ է, որտեղ մութ շերտերը խառնված են տարօրինակ լույսի հետ՝ ընդգծելով այս այլաշխարհիկ դժոխքի ճնշող մթնոլորտը։",
    instock: false,
    size: "150x200 cm",
    timer: "2024-02-14",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2024-12-28T23:22:33.563Z",
    },
    __v: 1,
  },
  {
    _id: 7,
    titleEN: "Autograph",
    titleRU: "Автограф",
    titleAM: "Ինքնագիր",
    imgs: [image2_0, image2_1],
    descriptionRU: "Фигура словно проходит через пространство символов и форм.Белая птица на плече — знак внутренней тишины и свободы, а лицо, разделённое на слои, говорит о поиске себя и целостности.",
    descriptionEN: "The figure moves through a space of symbols and forms.The white bird on the shoulder is a sign of inner silence and freedom, while the layered face speaks of the search for identity.",
    descriptionAM: "Կերպարը շարժվում է խորհրդանիշների և ձևերի միջով։Ուսին նստած սպիտակ թռչունը ներքին լռության ու ազատության նշան է, իսկ շերտավորված դեմքը պատմում է ինքնության որոնման մասին։",
    instock: true,
    size: "70x100",
    timer: "⠀",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2025-01-25T13:20:10.309Z",
    },
    __v: 0,
  },
  // {
  //   _id: 8,
  //   titleEN: "Sea Nymph",
  //   titleRU: "Морская нимфа",
  //   titleAM: "Ջրային փերի",
  //   imgs: [image3_0, image3_1, image3_2, image3_3, image3_4, image3_5, image3_6],
  //   descriptionRU: "⠀",
  //   descriptionEN: "⠀",
  //   descriptionAM: "⠀",
  //   instock: true,
  //   size: "⠀",
  //   timer: "⠀",
  //   ktavEN: "Canvas",
  //   ktavRU: "Холст",
  //   ktavAM: "Կտավ",
  //   yuxanerkEN: "oil",
  //   yuxanerkRU: "масло",
  //   yuxanerkAM: "յուղաներկ",
  //   department: "Paintings",
  //   bg: true,
  //   createdAt: {
  //     $date: "2025-01-25T13:21:41.213Z",
  //   },
  //   __v: 0,
  // },
  {
    _id: 9,
    titleEN: "Improvisation",
    titleRU: "Импровизация",
    titleAM: "Իմպրովիզ",
    imgs: [image5_0],
    descriptionRU: "Яркий букет подсолнухов и полевых цветов. Жёлтое, синее, красное, фиолетовое — краски танцуют, переполняя холст радостью и свободой.",
    descriptionEN: "Vibrant bouquet of sunflowers and wildflowers. Yellow, blue, red, purple — colors dance across the canvas, bursting with joy and freedom.",
    descriptionAM: "Վառ արևածաղիկների փունջ՝ դաշտային ծաղիկներով լի: Դեղին, կապույտ, կարմիր, մանուշակագույն գույները պարում են կտավի վրա՝ լցնելով ուրախությամբ ու ազատությամբ:",
    instock: false,
    size: "80x80",
    timer: "⠀",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2025-01-25T13:23:00.193Z",
    },
    __v: 0,
  },
    {
      _id: 10,
    titleEN: "Melody of the soul",
    titleRU: "Мелодия души",
    titleAM: "Հոգու մեղեդի",
    imgs: [image4_0],
    descriptionRU: "Музыка здесь выходит за пределы звука. Винил становится временем, прикосновение — моментом тишины, а пространство вокруг начинает смотреть и слушать. Это картина о внимании, в котором звук превращается в ощущение.",
    descriptionEN: "Music here goes beyond sound. The vinyl becomes time, the touch turns into a moment of silence, and the space around begins to watch and listen. This is a painting about attention, where sound transforms into sensation.",
    descriptionAM: "Երաժշտությունն այստեղ դուրս է գալիս ձայնի սահմաններից։ Վինիլը դառնում է ժամանակ, հպումը՝ լռության պահ, իսկ շուրջը գտնվող տարածքը սկսում է նայել ու լսել։ Սա ուշադրության մասին պատկեր է, որտեղ ձայնը վերածվում է զգացողության։",
    instock: false,
    size: "⠀",
    timer: "⠀",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2025-01-25T13:23:32.740Z",
    },
    __v: 0,
  },

  {
    _id: 11,
    titleEN: "The Battle of Bread and Honey",
    titleRU: "Борьба хлеба и мёда",
    titleAM: "Հացի և մեղրի պայքարը",
    imgs: [
      image10_0
    ],
    descriptionRU: "На шахматном поле — два рыцаря на белых конях, сражаются за чаши весов равновесия:⠀",
    descriptionEN: "On a chessboard battlefield — two knights on white steeds, clash beneath the scales of balance:",
    descriptionAM: "Շախմատի դաշտում՝ երկու ասպետներ՝ սպիտակ ձիերի վրա, մարտնչում են հավասարակշռության կշեռքի համար:⠀",
    instock: false,
    size: "150x2",
    timer: "⠀",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2025-01-25T13:25:15.845Z",
    },
    __v: 1,
  },
  {
    _id: 12,
    titleEN: "Music of the Forgotten World",
    titleRU: "Музыка забытого мира",
    titleAM: "Մոռացված աշխարհի երաժշտությունը",
    imgs: [
      image11_0
    ],
    descriptionRU: "Эта работа о вечном ритме жизни, что никогда не умирает, даже когда миры исчезают.",
    descriptionEN: "This work is about the eternal rhythm of life that never dies, even when worlds vanish.",
    descriptionAM: "Այս աշխատանքը հավերժ կյանքի ռիթմի մասին է, որը երբեք չի մեռնում, նույնիսկ երբ աշխարհները անհետանում են։⠀",
    instock: true,
    size: "150x2",
    timer: "⠀",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2025-01-25T13:25:15.845Z",
    },
    __v: 1,
  },
  {
    _id: 13,
    titleEN: "Self-defence",
    titleRU: "Самозащита",
    titleAM: "Ինքնապաշտպանություն",
    imgs: [
     image13_3, image13_4, image13_6, image13_0, image13_1, image13_2,   image13_5, image13_4
    ],
    descriptionRU: "Картина символизирует внутреннюю борьбу и защиту человека от внешнего мира. Листья окружили фигуру, словно природный щит, скрывая её от посторонних глаз. Замкнутый круг вокруг лица героини — это пространство её личной свободы и спокойствия. Маленькие рыбки, движущиеся вокруг, напоминают мысли и эмоции, которые стремятся к гармонии. Яркий розовый силуэт птицы символизирует надежду и внутреннюю силу, несмотря на сложные обстоятельства. Фиолетовые и зелёные тона добавляют мистичности и глубины образу. ",
    descriptionEN: "The painting symbolizes inner struggle and a person’s defense against the outside world. Leaves surround the figure like a natural shield, hiding her from external gazes. The enclosed circle around her face represents a space of personal freedom and tranquility. The small fish swimming around symbolize thoughts and emotions seeking harmony. The bright pink silhouette of a bird represents hope and inner strength, despite challenging circumstances. The purple and green tones add a sense of mysticism and depth to the image.",
    descriptionAM: "Նկարը խորհրդանշում է ներքին պայքարը և մարդու ինքնապաշտպանությունը արտաքին աշխարհից։ Տերևները շրջապատում են կերպարը՝ ստեղծելով բնության վահան, որը նրան պաշտպանում է։ Դեմքի շուրջ փակ շրջանակը խորհրդանշում է անձնական ազատության և հանգստության տարածքը։ Փոքրիկ ձկները, որոնք լողում են շուրջը, արտացոլում են մտքերն ու զգացմունքները, որոնք ձգտում են ներդաշնակության։ Վառ վարդագույն թռչունը հույսի և ներքին ուժի խորհրդանիշն է բարդ իրավիճակների մեջ։ Մանուշակագույնի և կանաչի երանգները լրացնում են խորհրդավորությունն ու խորությունը։",
    instock: true,
    size: "80x150",
    timer: "⠀",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2025-01-25T13:25:15.845Z",
    },
    __v: 1,
  },
  {
    _id: 14,
    titleEN: "Aesthetics ",
    titleRU: "Эстетика",
    titleAM: "Էսթետիկա",
    imgs: [
      image14_0, image14_1, image14_2, image14_3, image14_4
    ],
    descriptionRU: "На картине изображён яркий мир, наполненный символами природы и человека. Центральное место занимают руки, переплетённые с растениями и золотыми рыбками, которые кажутся живыми. Цветы и листья создают ощущение гармонии, а глаза, будто спрятанные в листве, добавляют таинственности. В правой части картины виднеется лицо, частично скрытое в синем фоне, что создаёт атмосферу мистики и глубокого погружения. Картина наполнена сине-зелёными и золотистыми оттенками, символизирующими природу, спокойствие и мечты.",
    descriptionEN: "The painting portrays a vibrant world filled with symbols of nature and humanity. Central to the artwork are hands intertwined with plants and golden fish that seem alive. Flowers and leaves create a sense of harmony, while the eyes hidden within the foliage add an element of mystery. In the right section, a partially obscured face emerges against a deep blue background, evoking mysticism and introspection. The painting is rich with blue-green and golden hues, symbolizing nature, tranquility, and dreams.",
    descriptionAM: "Նկարի մեջ պատկերված է վառ աշխարհ, որտեղ միահյուսվում են բնության և մարդկային խորհրդանշանները։ Կենտրոնում պատկերված են ձեռքեր, որոնք միախառնվել են բույսերի և ոսկեգույն ձկների հետ, որոնք կարծես կենդանի լինեն։ Ծաղիկներն ու տերեւները ներդաշնակության զգացողություն են ստեղծում, իսկ տերևների արանքում թաքնված աչքերը առեղծվածային շունչ են հաղորդում։ Աջ կողմում երեւում է մասամբ ծածկված դեմք՝ կապույտ երանգների ֆոնի վրա, ինչը միստիկա եւ խորը ինքնամփոփության զգացողություն է առաջացնում։ Նկարը հարուստ է կապույտ-կանաչ և ոսկեգույն երանգներով, որոնք խորհրդանշում են բնությունը, հանգստությունը եւ երազանքները։",
    instock: false,
    size: "95x95",
    timer: "⠀",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2025-01-25T13:25:15.845Z",
    },
    __v: 1,
  },
  {
    _id: 14,
    titleEN: "The blues of your soul ",
    titleRU: "Блюз твоей души",
    titleAM: "Քո հոգու բլյուզը",
    imgs: [
      image15_0, image15_1, image15_2, image15_3, image15_4, image15_5, image15_6
    ],
    descriptionAM: "Նկարում պատկերված է ֆանտաստիկ աշխարհ, որտեղ մարդկային կերպարը միահյուսվում է աբստրակտ տարրերի և վառ գույների հետ։ Կենտրոնական կերպարը ձեռքերում պահում է մեծ աչքով ձկան տեսքով առարկա, որը խորհրդանշում է տեսլականն ու ներաշխարհը։ Դեմքերը, նախշերն ու երկրաչափական ձևերը սահուն միախառնվում են ալիքաձև գծերի հետ՝ ստեղծելով երաժշտության և ժամանակի հոսքի զգացողություն։ Ստորին հատվածում պատկերված ավազի ժամացույցը և ոսկեգույն ձկները խորհրդանշում են ակնթարթի անցողիկությունն ու հոգու ռիթմի խորքային ընկղմումը։ Գունապնակը հագեցած է կապույտ, կարմիր և դեղին երանգներով, որոնք փոխանցում են «քո հոգու բլյուզի» ներդաշնակությունն ու դինամիկան։",
    descriptionEN: "The painting portrays a fantastical world where the human figure blends with abstract elements and vibrant colors. The central character holds a fish-shaped object with a large eye, symbolizing vision and the inner world. Faces, patterns, and geometric shapes merge seamlessly with flowing lines, creating a sense of music and the flow of time. The hourglass at the bottom of the composition, accompanied by golden fish, represents the fleeting nature of the moment and a deep immersion into the soul’s rhythm. The palette is enriched with shades of blue, red, and yellow, conveying harmony and the dynamic energy of the “blues” of the soul.",
    descriptionRU: "На картине изображён фантастический мир, где человеческая фигура переплетается с абстрактными элементами и яркими цветами. Центральный персонаж держит в руках предмет в виде рыбы с большим глазом, символизирующий видение и внутренний мир. Лица, узоры и геометрические фигуры плавно сочетаются с волнистыми линиями, создавая ощущение музыки и течения времени. Песочные часы внизу композиции и золотые рыбки символизируют неуловимость момента и глубокое погружение в душевный ритм. Палитра насыщена синими, красными и жёлтыми оттенками, передавая гармонию и динамику «блюза» души.",
    instock: false,
    size: "100x80",
    timer: "⠀",
    ktavEN: "Canvas",
    ktavRU: "Холст",
    ktavAM: "Կտավ",
    yuxanerkEN: "oil",
    yuxanerkRU: "масло",
    yuxanerkAM: "յուղաներկ",
    department: "Paintings",
    bg: true,
    createdAt: {
      $date: "2025-01-25T13:25:15.845Z",
    },
    __v: 1,
  },
];
